import React from 'react';

import { ColumnDividerBox } from '@eika-kortbetjening/column-divider-box';
import { IconTypes } from '@eika/icon';

import { Navigate, SearchParams, useConfigLink, useLinkProducer } from '@/domain/app';
import { CreditCardService, CreditCardPanelItem } from '@/domain/card';
import { CreditCardControlPanel } from '@/pages/card-details/components/KbCardDetails/CardControlPanel';
import piwik from '@/piwik/piwik';

import { CreditCard, CreditCardAccount } from '@generated-types';
import useText from '@hooks/use-text';

import { CardPayment } from '../CardPayment/CardPayment';
import { CreditInformation } from '../CreditInformation';

type CardBalancePanelProps = {
    card: CreditCard;
    account: CreditCardAccount;
};

export const CardBalancePanel = ({ card, account }: CardBalancePanelProps) => {
    const text = useText();

    const linkProducer = useLinkProducer();

    const linkExtraPayment = useConfigLink('linkExtraPayment', { url: '/nettbank/betaling/ny-betaling' });

    const link = linkProducer('CARD_PAGE')({
        [SearchParams.CARD_TYPE]: 'CREDIT',
        [SearchParams.ACCOUNT_ID]: account.accountId,
        [SearchParams.CARD_ID]: card.id,
    });

    const isOwnerOfCard = CreditCardService.isOwnerOfCard(card);

    return (
        <div className="card-balance-with-functionality">
            <ColumnDividerBox>
                <ColumnDividerBox.Item>
                    <CreditCardControlPanel card={card} />
                </ColumnDividerBox.Item>
                <ColumnDividerBox.Item align="center" noDivider>
                    <CreditInformation account={account} />
                </ColumnDividerBox.Item>
                <ColumnDividerBox.Item noPadding>
                    <CreditCardPanelItem
                        hide={!isOwnerOfCard}
                        iconType={IconTypes.BETALE_24}
                        piwikTag={piwik.transactions.functionalityButtonExtraPayment}
                        url={Navigate.toExtraPaymentLink(
                            linkExtraPayment.url,
                            account.billingSummary.paymentBankAccountNumber,
                            account.billingSummary.kidNumber,
                        )}
                        title={text.cardButtonExtraPayment}
                    />
                    <CardPayment card={card} account={account} />
                    <CreditCardPanelItem
                        hide={false}
                        iconType={IconTypes.TANNHJUL_24}
                        piwikTag={piwik.cardDetails.cardFunctionalityLinkTransaksjoner}
                        url={link}
                        title={isOwnerOfCard ? text.cardSettingsHeaderOwner : text.cardSettingsHeader}
                    />
                </ColumnDividerBox.Item>
            </ColumnDividerBox>
        </div>
    );
};
